<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">


  <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">

        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('id') | formControl" [id]="'id'"
                          [isReadOnly]="editableForm" [label]="'Ingrese ID*'" [maxlength]="'8'"
                          [mostrarImg]="false"
                          [placeholder]="'ID'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="id">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('description') | formControl" [id]="'description'"
                          [label]="'Ingrese Turno*'" [mostrarImg]="false" [placeholder]="'Turno'" [rutaImagen]=""
                          [type]="'text'"
                          formControlName="description">
          </app-lfsa-input>
        </div>

        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('entrada1') | formControl" [id]="'entrada1'"
                          [label]="'Ingrese Hora Inicio 1'" [mostrarImg]="false" [placeholder]="'Hora Inicio 1'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="entrada1">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('salida1') | formControl" [id]="'salida1'"
                          [label]="'Ingrese Hora Fin 1'" [mostrarImg]="false" [placeholder]="'Hora Fin 1'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="salida1">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('entrada2') | formControl" [id]="'entrada2'"
                          [label]="'Ingrese Hora Inicio 2'" [mostrarImg]="false" [placeholder]="'Hora Inicio 2'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="entrada2">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('salida2') | formControl" [id]="'salida2'"
                          [label]="'Ingrese Hora Fin 2'" [mostrarImg]="false" [placeholder]="'Hora Fin 2'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="salida2">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('entrada3') | formControl" [id]="'entrada3'"
                          [label]="'Ingrese Hora Inicio 3'" [mostrarImg]="false" [placeholder]="'Hora Inicio 3'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="entrada3">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('salida3') | formControl" [id]="'salida3'"
                          [label]="'Ingrese Hora Fin 3'" [mostrarImg]="false" [placeholder]="'Hora Fin 3'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="salida3">
          </app-lfsa-input>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                   [formularioValido]="formulario.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formulario>
    </form>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista" [innTemplateButton]="innTemplateButtonAddTipoTurno"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonAddTipoTurno>
    <div class="col-md-6">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <a (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregarTipoTurno}}
          </a>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #enviarTemplate>
    <section class="section">
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style" [pagination]="true"
                           [rowData]="rowData" [rowSelection]="rowSelection"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
